const consonant = [
  'b',
  'c',
  'd',
  'f',
  'g',
  'h',
  'j',
  'k',
  'l',
  'm',
  'n',
  'p',
  'q',
  'r',
  's',
  't',
  'v',
  'w',
  'x',
  'y',
  'z',
]
const vowel = ['a', 'e', 'i', 'o', 'u', 'y']
const number = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
const dbl = [
  'aj',
  'aq',
  'av',
  'az',
  'cy',
  'dy',
  'eh',
  'ek',
  'fy',
  'gy',
  'ib',
  'if',
  'ih',
  'ii',
  'ij',
  'ik',
  'iq',
  'iu',
  'iv',
  'iw',
  'ix',
  'iy',
  'jy',
  'ko',
  'ku',
  'ky',
  'oc',
  'og',
  'oh',
  'oj',
  'ok',
  'oq',
  'ov',
  'oy',
  'oz',
  'qa',
  'qi',
  'qo',
  'qy',
  'sy',
  'uc',
  'uf',
  'ug',
  'uh',
  'uj',
  'uk',
  'uq',
  'uu',
  'uv',
  'uw',
  'ux',
  'uy',
  'uz',
  'vu',
  'vy',
  'wu',
  'wy',
  'xa',
  'xi',
  'xu',
  'xy',
  'yb',
  'yc',
  'yd',
  'yf',
  'yg',
  'yh',
  'yi',
  'yj',
  'yk',
  'ym',
  'yp',
  'yq',
  'yr',
  'yt',
  'yv',
  'yw',
  'yx',
  'yy',
  'yz',
]
const whitelist = ['cpl', 'srx', 'tkt', 'pbm', 'slp', 'ch']

let regex = null
let regexwl = null

const makeRegex = (tab) => {
  let strregex = '('
  for (let i = 0; i < tab.length; i++) {
    strregex += i === 0 ? tab[i] : `|${tab[i]}`
  }
  strregex += ')'

  return new RegExp(strregex, 'gi')
}

function unique(tab) {
  const n = {}
  const r = []
  for (let i = 0; i < tab.length; i++) {
    if (!n[tab[i]]) {
      n[tab[i]] = true
      r.push(tab[i])
    }
  }
  return r
}

function generateCombinations(arr) {
  for (let i = 0; i < arr.length; i++) {
    for (let j = 0; j < arr.length; j++) {
      dbl.push(`${arr[i]}${arr[j]}`)
    }
  }
}

generateCombinations(consonant)
generateCombinations(vowel)
generateCombinations(number)

regex = makeRegex(dbl)
regexwl = makeRegex(whitelist)

export default function randomStringDetector(str, options = { min: 5 }) {
  const settings = { ...options }
  if (typeof options === 'object') {
    if (typeof options.min === 'number' && options.min >= 0) {
      settings.min = options.min
    }
  }

  if (str.length < settings.min) return false

  let score = 0

  let tab = str.match(/([a-zA-Z]{2})(?=(.*?\1){2})/g)

  if (Array.isArray(tab)) {
    tab = unique(tab)

    const tmpregex = makeRegex(tab)
    let result = tmpregex.exec(str)
    while (result) {
      score++
      result = tmpregex.exec(str)
    }
  }

  let duplet = ''
  for (let i = 0; i < str.length - 1; i++) {
    duplet = str.substr(i, 2)
    let result = regex.exec(duplet)
    while (result) {
      score++
      result = regex.exec(duplet)
    }
  }

  let result = regexwl.exec(str)
  while (result) {
    if (result[0].length === 3) score -= 2
    else if (result[0].length === 2) score--
    result = regexwl.exec(str)
  }

  return score / (str.length - 1)
}
